"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _CanvasFactory = _interopRequireDefault(require("../../CanvasFactory"));

var _LayerRenderer = _interopRequireDefault(require("../../render/LayerRenderer"));

var _LayerTransformData = _interopRequireDefault(require("../../layers/LayerTransformData"));

var _Rectangle = _interopRequireDefault(require("../../../models/geometry/Rectangle"));

var _setContextTransform = _interopRequireDefault(require("./setContextTransform"));

var _setImageSmoothing = _interopRequireDefault(require("../../../utils/canvas/setImageSmoothing"));

var _ContentFrameData = _interopRequireDefault(require("../../store/ContentFrameData"));

var RENDER_PADDING_FACTOR = 1.2;

var LayerTransformer = /*#__PURE__*/function () {
  function LayerTransformer(renderDimensions, canvasFactory, imageSmoothing) {
    (0, _classCallCheck2["default"])(this, LayerTransformer);
    (0, _defineProperty2["default"])(this, "_canvas", null);
    (0, _defineProperty2["default"])(this, "_context", null);
    (0, _defineProperty2["default"])(this, "_dimensions", null);

    if (!_Rectangle["default"].isValidRectangle(renderDimensions)) {
      throw new Error('renderDimensions must be a valid rectangle');
    }

    if (!_CanvasFactory["default"].isCanvasFactory(canvasFactory)) {
      throw new Error('canvasFactory must be CanvasFactory');
    } // Padded to avoid edge distortion of filters


    var renderWidth = renderDimensions.width * RENDER_PADDING_FACTOR;
    var renderHeight = renderDimensions.height * RENDER_PADDING_FACTOR;
    this._dimensions = new _Rectangle["default"](0, 0, renderWidth, renderHeight);
    this._canvas = canvasFactory.getCanvas({
      height: this._dimensions.height,
      width: this._dimensions.width
    });
    this._context = this._canvas.getContext('2d');
    (0, _setImageSmoothing["default"])(this._context, Boolean(imageSmoothing));
    (0, _setContextTransform["default"])(this._context, 0, 0, 1, 1, 0, this._dimensions);
  }

  (0, _createClass2["default"])(LayerTransformer, [{
    key: "transformAndRenderLayer",
    value: function transformAndRenderLayer(renderer, currentFrame, contentFrameData, layerTransformData) {
      if (!_LayerRenderer["default"].isLayerRenderer(renderer)) return null;
      if (!_ContentFrameData["default"].isContentFrameData(contentFrameData)) return null;
      if (!_LayerTransformData["default"].isLayerTransformData(layerTransformData)) return null; // Clear context

      this._context.clearRect(-this._dimensions.width / 2, -this._dimensions.height / 2, this._dimensions.width, this._dimensions.height);

      var rotation = layerTransformData.rotation,
          scaleX = layerTransformData.scaleX,
          scaleY = layerTransformData.scaleY,
          scaledHeight = layerTransformData.scaledHeight,
          scaledWidth = layerTransformData.scaledWidth,
          translationX = layerTransformData.translationX,
          translationY = layerTransformData.translationY; // No need to draw if zero width or height.

      if (scaledWidth <= 0 || scaledHeight <= 0) {
        return null;
      }

      (0, _setContextTransform["default"])(this._context, translationX, translationY, scaleX, scaleY, rotation, this._dimensions);
      renderer.drawLayerAtFrame(this._context, currentFrame, contentFrameData, layerTransformData);
      (0, _setContextTransform["default"])(this._context, 0, 0, 1, 1, 0, this._dimensions);
      return this._canvas;
    }
  }, {
    key: "dimensions",
    get: function get() {
      return this._dimensions;
    }
  }], [{
    key: "isLayerTransformer",
    value: function isLayerTransformer(inValue) {
      return inValue instanceof LayerTransformer;
    }
  }]);
  return LayerTransformer;
}();

exports["default"] = LayerTransformer;